import { render, staticRenderFns } from "./PlaylistMusicFiles.vue?vue&type=template&id=95b7968c&"
import script from "./PlaylistMusicFiles.vue?vue&type=script&lang=js&"
export * from "./PlaylistMusicFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports